/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useLayoutEffect } from 'react';
import { PropTypes } from 'prop-types';
import { Card, CardTitlePrimary, CardContent } from '@design-system-coopeuch/web';
import { FuturaTarjetaWrapper } from './styles';
import ilustracionCuentaVista from '../../../assets/img/icon/ilustración-cuentavista.svg';
import { properties } from '../../../../utils/properties';

const RequisitosInfo = ({ requisitosRef }) => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    requisitosRef.current = true;
    return () => {
      requisitosRef.current = false;
    };
  }, []);

  return (
    <FuturaTarjetaWrapper>
      <div className="req-div">
        <Card>
          <CardTitlePrimary title={properties.futuratarjeta.hazteSocioRequisitosTitulo} />
          <CardContent>
            <div className="info-cuatro">
              <img className="usertarjeta" src={ilustracionCuentaVista} alt="usertarjeta" />
            </div>
            <div className="info-cinco">
              <p className="p-tres">{properties.futuratarjeta.hazteSocioRequisitosSubtitulo}</p>
              <p className="p-coment">
                <span>{properties.futuratarjeta.hazteSocioRequisitosDesc1}</span>
                <span><strong>{properties.futuratarjeta.hazteSocioRequisitosDesc2}</strong></span>
                <span>{properties.futuratarjeta.hazteSocioRequisitosDesc3}</span>
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </FuturaTarjetaWrapper>
  );
};

RequisitosInfo.propTypes = {
  requisitosRef: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default RequisitosInfo;
